import { api } from '@gik/core/api';
import { IAnalyticsProps } from '@gik/core/utils/Analytics';

const path = 'emailUsers';

export const emailUserTags = {
  createPageReminders: 'create-page-reminders',
};

export interface ITriggerEmailUserAnalyticsEventRequest {
  userEmail: string;
  eventName: string;
  eventParameters?: IAnalyticsProps;
}

export interface IEmailUserTagsRequest {
  userEmail: string;
  tags: string[];
}

export async function triggerEmailUserAnalyticsEvent(request: ITriggerEmailUserAnalyticsEventRequest) {
  await api.post(`${path}/events`, {
    json: request,
  });
}

export async function addEmailUserTags(request: IEmailUserTagsRequest) {
  await api.post(`${path}/tags`, {
    json: request,
  });
}

export async function removeEmailUserTags(request: IEmailUserTagsRequest) {
  await api.delete(`${path}/tags`, {
    json: request,
  });
}
